import { print } from 'graphql'
import { Address } from 'shopify-types'

import { GlobalRequestOptions } from '@/shopify/types'

import { storefrontClient } from '../..'
import { CreateAddressDocument, type CreateAddressMutation } from '../../__generated/storefront'
import { mapGQLAddressToAddress } from './graphql'

export type CreateAddressInput = Readonly<Omit<Address, 'id' | 'phone' | 'province'>>

export const createAddress =
  (options: GlobalRequestOptions) => async (token: string, address: CreateAddressInput) => {
    const response = await storefrontClient.request<CreateAddressMutation>(
      print(CreateAddressDocument),
      {
        variables: {
          address,
          customerAccessToken: token,
          language: options.language,
        },
      },
    )

    const payload = response.data?.customerAddressCreate

    if (!payload?.customerAddress) {
      throw new Error('Failed to create address')
    }

    return mapGQLAddressToAddress(payload.customerAddress)
  }
